import { IShopConfig } from '@/client/types/ShopConfig'
import { api } from '@/client/utils'

/**
 * Call the private API to retrieve the shops configuration like customer service opening hours
 * @param domain to identify the shop to get configurations for
 */
export const getShopConfig = async (domain: string) => {
  const url = `/shopConfig?domain=${domain}`
  const { data } = await api.get<IShopConfig>(url)
  return data
}
